module.exports = __webpack_public_path__ + "img/def-head.65d8327a.jpeg";